module.exports = {
  message: {
    service_desc: '透過此工具來轉換 COS 代幣的格式，包括<strong>主網原生 COS、ERC-20、BEP-20</strong>',
    choose_token_type: '代幣轉換方向',
    fee_tips: '',
    token_type_erc20_to_bep2: 'ERC-20 => BEP2',
    token_type_erc20_to_native: 'ERC-20 => 主網原生 COS',
    token_type_bep2_to_erc20: 'BEP2 => ERC-20',
    token_type_bep2_to_native: 'BEP2 => 主網原生 COS',
    token_type_native_to_erc20: '主網原生 COS => ERC-20',
    token_type_native_to_bep2: '主網原生 COS => BEP2',
    token_type_bep20_to_native: 'BEP-20 => 主網原生 COS',
    token_type_native_to_bep20: '主網原生 COS => BEP-20',
    enter_address: '轉換目的帳號/地址',
    enter_exchange_memo: 'Memo（檢測到目的地址為交易所，請填入交易所提供的 Memo 以確保順利接收 COS 代幣）',
    create_account_tips: '沒有帳號嗎？馬上創建',
    next_btn: '下一步',
    start_over_btn: '重新開始',
    ready_to_swap: '準備好進行代幣轉換',
    transfer_prefix: '將你的 {token} 轉帳到',
    address: '帳號/地址',
    memo: 'MEMO',
    auto_swap_desc: '請確保轉帳到正確的帳號/地址，代幣轉換工具收到轉帳後，' +
      '會將相應的代幣數量轉入指定的目的錢包。<strong>（此過程約需五至三十分鐘）<strong>',
    auto_swap_desc_memo: '請確保轉帳到正確的帳號/地址並附帶上述 MEMO，代幣轉換工具收到轉帳後，' +
      '會將相應的代幣數量轉入指定的目的錢包。<strong>（此過程約需五至三十分鐘）<strong>',
    main_net_address: 'Contentos 主網帳號',
    bep2_address: 'BEP2 錢包地址',
    erc20_address: 'ERC-20 錢包地址',
    bep20_address: 'BEP-20 錢包地址',
    main_net_token: 'COS MainNet',
    bep2_token: 'BEP2 COS',
    erc20_token: 'ERC-20 COS',
    bep20_token: 'BEP-20 COS',
    ok: '確定',
    Cancel: '取消',
    tips: '提示',
    enter_address_tips: '請輸入正確的地址',
    enter_exChange_memo_tips: '請輸入正確的 Memo',
    swap_address_invalid: '此地址不符合規範',
    swap_address_not_exit: '此帳號不存在',
    swap_type_invalid: '無效的代幣轉換方向',
    swap_system_error: '系統錯誤，請稍後再試',
    swap_unknown_error: '發生未知問題，請稍後再試',
    swap_memo_invalid: 'Memo不符合規範',
    invalid_bnb_exChange_memo_tips: '幣安交易所Memo必須是數字',
    paste_warning: '將地址貼上時，請確認與複製的內容相符',
    fee_notice: '請注意：每筆{token}轉換將收取{fee} COS手續費以支應帳戶轉帳的gas費用，不足{fee} COS的轉換將不會被處理。',
    fee_subject_to_change: '手續費可能變動且不另行通知',
    view_status: '瀏覽目前轉換狀況',
    prev_step: '上一步',
    go_back: '返回',
    transfer_prefix_before: '將你的',
    transfer_prefix_after: '轉帳到',
    copy_memo: '複製 MEMO',
    copy_address: '複製地址',
    copy_success: '複製成功',
    memo_warning: '請注意：轉帳時請務必附上正確 MEMO。系統將依實際入帳數量完成轉換並轉回你填寫的地址，請勿省略 MEMO。',
    col_time: '時間',
    col_target_format: '目標格式',
    col_target_account: '目標帳戶',
    col_amount: '匯入金額',
    col_status: '狀態',
    loading: '載入中\u2026',
    no_data: '暫無資料',
    next_update_hint: '資料將於 {time} 後更新',
    status_done: '已完成',
    status_pending: '處理中',
    panel_title_status: '目前轉換狀況',
    panel_title_step1: '幣種轉換工具',
    panel_title_step2: '準備好進行代幣轉換',
    panel_subtitle_status: '選擇來源代幣格式以查看轉換紀錄',
    source_network: '來源代幣格式',
    conversion_record: '轉換紀錄',
    new_label: '新'
  }
}
